<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        @if(submittedRequests.length === 0){
        <div class="row">
            <div class="col col-12">
                @if(checkingPermission){
                <div class="text-center">
                    <mat-spinner [diameter]="60"
                        style="display:inline-block; margin-left: 10px; top: 10px;"></mat-spinner>
                </div>
                }
                @else{
                <h1>reactivate PAS access</h1>
                <form lass="branded">
                    <fieldset class="pb-4">
                        <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                            <p><strong>pas user info</strong></p>
                        </legend>
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-6">
                                @if(!hasPermission){
                                You do not have access to PAS because no secrets have been shared with you
                                }
                                @else{
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>user name</mat-label>
                                    <input readonly [value]="userPrincipalName" name="userPrincipalName"
                                        formControlName="userPrincipalName" maxlength="64" matInput />
                                </mat-form-field>
                                }
                            </div>
                        </div>

                    </fieldset>
                </form>
                <mat-divider *ngIf="submitErrorMessage.errors.length > 0"></mat-divider>

                <div class="btn-toolbar d-flex justify-content-center pt-4 pb-4" role="toolbar">
                    <mat-spinner [diameter]="30" *ngIf="isSubmitting"
                        style="display:inline-block; margin-left: 10px; top: 10px;"></mat-spinner>
                    <div class="btn-group mr-2" role="group" *ngIf="!isSubmitting ">
                        <button class="button" type="button" (click)="onReactivate()">reactivate</button>
                    </div>
                </div>

                <display-http-error [message]="submitErrorMessage.message"
                    [errors]="submitErrorMessage.errors"></display-http-error>
                }
            </div>
        </div>
        }
        @else{
        <div class="row">
            <div class="col col-12">
                <a class="close-button" [routerLink]="['/passwords/reactivate']"><span
                        class="icon-remove close-button"></span></a>
                <h1>request submitted</h1>
                <display-http-error [message]="submitErrorMessage.message"
                    [errors]="submitErrorMessage.errors"></display-http-error>
                <display-requests [requests]="submittedRequests"></display-requests>
            </div>
        </div>
        }
    </section>
</main>